import {
  checkoutOptimizationStepSchema,
  triggerStepSchema,
} from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { z } from "zod";

const checkoutTreeFlowStepNoSplitSchema = z.object({
  hasActiveSplit: z.literal(false),
  steps: z.array(z.union([checkoutOptimizationStepSchema, triggerStepSchema])),
});

const checkoutTreeFlowStepWithSplitSchema = z.object({
  hasActiveSplit: z.literal(true),
  steps: z.array(z.union([checkoutOptimizationStepSchema, triggerStepSchema])),
  concludedSteps: z
    .array(z.union([checkoutOptimizationStepSchema, triggerStepSchema]))
    .optional(),
});

const checkoutTreeFlowStepSchema = z.discriminatedUnion("hasActiveSplit", [
  checkoutTreeFlowStepNoSplitSchema,
  checkoutTreeFlowStepWithSplitSchema,
]);

export const getCheckoutTreeFlowSteps = {
  input: z.null(),
  output: checkoutTreeFlowStepSchema,
};
export type GetCheckoutTreeFlowStepsOutput = z.infer<
  typeof getCheckoutTreeFlowSteps.output
>;
